import type React from 'react'
import { useLanguage } from '@/landing/contexts/LanguageContext'
import type { FindSheetPileSectionProps } from '@/types/components'

export const FindSheetPileSection: React.FC<FindSheetPileSectionProps> = ({ items = [] }) => {
  const { t } = useLanguage()

  return (
    <div className="mb-12">
      <h2
        className="text-3xl font-bold text-gray-900 mb-6"
        style={{
          fontFamily: 'Montserrat, sans-serif',
        }}
      >
        {t('main_page.search.or_find_a')}{' '}
        <span className="text-primary">{t('main_page.search.sheet_pile_section')}</span>
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {items.map((item) => (
          <a
            key={item.id}
            href={item.linkUrl}
            className="group flex flex-row items-center gap-2 p-2 border border-gray-200 rounded-lg hover:border-primary hover:shadow-lg transition-all duration-200"
          >
            <div className="w-16 h-10 flex-shrink-0 flex items-center justify-center overflow-hidden bg-white">
              {item.imageUrl ? (
                <img
                  src={item.imageUrl}
                  alt={item.name}
                  className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-200"
                  style={{ filter: 'grayscale(100%) contrast(1.5)' }}
                />
              ) : null}
            </div>
            <h3 className="flex-1 font-medium text-xs text-gray-900 group-hover:text-primary transition-colors whitespace-nowrap overflow-hidden text-ellipsis">
              {item.name}
            </h3>
          </a>
        ))}
      </div>
    </div>
  )
}
